<template>
    <div
        id="covid-19-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <ul>
            <li
                v-for="(update, index) in data.updates"
                :key="index"
                class="update"
            >
                <base-text type="h4">{{ date(update.date) }}</base-text>
                <base-text type="p" v-html="makeHtml(update.content)" />
            </li>
        </ul>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/covid-19.md';
    // LIBRARIES
    import moment from 'moment';
    import showdown from 'showdown';

    export default {
        name: 'covid-19',

        mixins: [dataLoader(data)],

        methods: {
            date(date) {
                return moment(date).format('MMMM Do YYYY, h:mm a');
            },

            makeHtml(content) {
                const converter = new showdown.Converter();
                return converter.makeHtml(content);
            },
        },
    };
</script>

<style lang="scss" scoped>
    #covid-19-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .update {
            &:not(:last-of-type) {
                margin-bottom: $standard-space;
            }

            .h4 {
                margin-bottom: 10px;
            }
        }
    }
</style>
